import {
  CANCEL_IMAGE_PREVIEW,
  SAVE_IMAGE,
  SAVE_IMAGE_FAILURE,
  SAVE_IMAGE_SUCCESS,
  UPDATE_BRIGHTNESS,
  UPDATE_CROPPING,
  UPDATE_CROP_SCALE,
  UPDATE_CROP_TOOL_PROPS,
  UPDATE_IMAGE_CROP,
  UPDATE_IMAGE_PROPS,
  UPDATE_PREVIEWING,
  UPDATE_SAVING,
  UPDATE_STAGE_PROPS,
  UPDATE_WAS_CROPPING,
  VIEW_IMAGE_PREVIEW,
} from './constants';

export const updatePreviewing = value => ({
  type: UPDATE_PREVIEWING,
  value,
});

export const updateCropping = value => ({
  type: UPDATE_CROPPING,
  value,
});

export const updateWasCropping = value => ({
  type: UPDATE_WAS_CROPPING,
  value,
});

export const updateSaving = value => ({
  type: UPDATE_SAVING,
  value,
});

export const updateBrightness = value => ({
  type: UPDATE_BRIGHTNESS,
  value,
});

export const updateImageCrop = value => ({
  type: UPDATE_IMAGE_CROP,
  value,
});

export const updateStageProps = props => ({
  type: UPDATE_STAGE_PROPS,
  props,
});

export const updateCropToolProps = props => ({
  type: UPDATE_CROP_TOOL_PROPS,
  props,
});

export const updateImageProps = props => ({
  type: UPDATE_IMAGE_PROPS,
  props,
});

export const updateCropScale = value => ({
  type: UPDATE_CROP_SCALE,
  value,
});

export const cancelImagePreview = wasCropping => ({
  type: CANCEL_IMAGE_PREVIEW,
  wasCropping,
});

export const saveImage = () => ({
  type: SAVE_IMAGE,
});

export const saveImageSuccess = () => ({
  type: SAVE_IMAGE_SUCCESS,
});

export const saveImageFailure = () => ({
  type: SAVE_IMAGE_FAILURE,
});

export const viewImagePreview = () => ({
  type: VIEW_IMAGE_PREVIEW,
});
